var JSON6 = require('json-6');

export const parseJSON = (json) => {
  return JSON6.parse(json);
}

export const getPropsData = (propsEl) => {
  let props = {};
  if(propsEl) {
    const jsonData = propsEl.innerHTML;
    props = JSON6.parse(jsonData);
  }
  return props;
}